<template>
  <v-card>
    <v-card-title>
      <h3 class="h3-header">{{ $t("pageHeader.reviewInvoice") }}</h3>
      <v-spacer> </v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line="single-line" hide-details>
      </v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="invoice" :search="search" :loading="loading" :sort-by="sortBy"
      :page.sync="page" :items-per-page="itemsPerPage">
      <template slot="items" slot-scope="props" @click="viewInvoice(props.item)">
        <td class="text-left small-td">{{ props.item.invoiceID }}</td>
        <td class="text-left small-td">
          {{ $moment(props.item.createDateTime).format("MM/DD/YYYY") }}
        </td>
        <td class="text-left small-td" v-if="props.item.paidDateTime">
          {{ $moment(props.item.paidDateTime).format("MM/DD/YYYY") }}
        </td>
        <td class="text-left small-td" v-else>
          <v-chip color="error" text-color="white" small>Not Paid</v-chip>
        </td>
        <td class="text-right small-td">{{ props.item.invoiceAmount | currency }}</td>
        <td class="justify-end layout px-0">
          <v-menu bottom="" left="">
            <v-btn slot="activator" icon="">
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list class="menu-button">
              <v-list-item @click="viewInvoice(props.item)">
                <v-list-item-title>{{ $t("buttons.view") }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="!props.item.paidDateTime" @click="payInvoice(props.item)">
                <Payment :paymentDialog="paymentDialog" :invoice="props.item" @close="paymentDialog = false"
                  @refresh="getList">
                </Payment>
                <v-list-item-title>{{ $t("buttons.pay") }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
        results.</v-alert>
    </v-data-table>
  </v-card>
</template>
<script>
import invoiceService from "../service.js";
import Payment from "../../Invoice/components/Payment";
import { mapGetters } from "vuex";

export default {
  props: ["storeID"],
  name: "invoice-list",
  data() {
    return {
      paymentDialog: false,
      sortBy: "createdAt",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      terminalURL: process.env.VUE_APP_TERMINALURL,
      headers: [
        {
          text: this.$t("labels.invoiceNumber"),
          align: "left",
          sortable: true,
          value: "invoiceID",
          width: "10%"
        },
        {
          text: this.$t("labels.invoiceDate"),
          value: "createDateTime",
          sortable: true
        },
        {
          text: this.$t("labels.paidDate"),
          value: "paidDateTime",
          sortable: true
        },
        {
          text: this.$t("labels.invoiceAmount"),
          value: "invoiceAmount",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      invoice: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "invoiceID",
        descending: true
      }
    };
  },
  computed: {},
  watch: {
    search() {
      if (this.search.length > 3 || this.search.length === 0) {
        this.getList();
      }
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      return invoiceService.getAllInvoice(this.storeID, {}).then(response => {
        this.invoice = response.data;
        this.loading = false;
        return response;
      });
    },
    payInvoice(data) {
      this.paymentDialog = true;
    },
    viewInvoice(data) {
      let routeData = this.$router.resolve({ path: `/invoice/${data.invoiceID}/view` });
      window.open(routeData.href, "newwindow", "width=800, height=950");
    }
  },
  components: {
    Payment
  }
};
</script>
